import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function American() {
  return (
    <ApiCommunityDirectoryPage
      community="American"
      eyebrow="American community guide"
      title="American favorites, businesses, and local essentials in San Antonio."
      
      tags={["American community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the American community guide?"
      modalIdPrefix="american-directory"
    />
  );
}
